import React, { useState } from "react"

import { addNewObject } from "../../../../Loaders"
import PageLoadingPanel from "../../../../shared_components/widgets/PageLoadingPanel"
import AddEntityForm from "./AddEntityForm"
import { handleError } from "./utils"

const baseEntity = { name: "", description: "" }

export default function NewEntityForm({
  type = "task",
  parentID,
  getTextStr,
  onSuccess,
  permission,
  expManagerField = {},
}) {
  const isTask = type === "task"
  const url = isTask ? "/warehouse/project_tasks/" : "/warehouse/experiments/"
  const parentInfo = isTask ? { project_id: parentID } : { project_task_id: parentID }
  const defaultEntity = isTask
    ? baseEntity
    : { ...baseEntity, experiment_manager_id: expManagerField?.defaultOpt?.id }
  const [entityForm, setEntityForm] = useState(defaultEntity)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const handleCreateEntity = (e) => {
    e.preventDefault()
    setLoading(true)
    addNewObject(url, { ...entityForm, ...parentInfo }, true)
      .then((entity) => {
        setLoading(false)
        setEntityForm(defaultEntity)
        onSuccess(entity.id)
      })
      .catch((err) => {
        setLoading(false)
        handleError(err, setError)
      })
  }

  return (
    <>
      {loading ? (
        <PageLoadingPanel />
      ) : (
        <>
          {parentID && (
            <AddEntityForm
              getTextStr={getTextStr}
              onSubmit={handleCreateEntity}
              entityForm={entityForm}
              setValue={(key, val) => {
                setEntityForm({ ...entityForm, [key]: val })
                error && setError(null)
              }}
              extraRows={isTask ? [] : [expManagerField]}
              error={error}
              disabled={!permission || loading}
            />
          )}
        </>
      )}
    </>
  )
}
